module.exports = __webpack_public_path__ + "static/media/Beach5.6745d325.jpg";